import React from 'react'
import { call } from 'wasm-imagemagick'
// import FileType from 'file-type'
import { Button } from '@material-ui/core'
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
// import CardMedia from '@material-ui/core/CardMedia';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const styles = theme => ({
  inputImg: {
    maxWidth:400,
    background: "url(data:image/gif;base64,R0lGODlhEAAQAPEBAAAAAL+/v////wAAACH5BAAAAAAALAAAAAAQABAAAAIfjG+iq4jM3IFLJipswNly/XkcBpIiVaInlLJr9FZWAQA7) fixed",
  },
  outputImg: {
    maxWidth: 256,
    background: "url(data:image/gif;base64,R0lGODlhEAAQAPEBAAAAAL+/v////wAAACH5BAAAAAAALAAAAAAQABAAAAIfjG+iq4jM3IFLJipswNly/XkcBpIiVaInlLJr9FZWAQA7) fixed",
  },
  button: {
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  inputFileBtnHide: {
    opacity:0,
    appearance: 'none',
    position: 'absolute',
  },
});


class ImageUploadButton extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            inputImage: '',
            inputFile: null,
            outputImage: '',
            isLoading: false,
            size16: false,
            size24: false,
            size32: false,
            size48: false,
            size64: false,
            size128: false,
            size256: false,
            selection: new Set([]),
        }
    }

    readFileAsync(file) {
        return new Promise((resolve, reject) => {
          let reader = new FileReader();
      
          reader.onload = () => {
            resolve(reader.result);
          };
      
          reader.onerror = reject;
      
          reader.readAsArrayBuffer(file);
        })
      }
  
    handleChange = event => {
        const selection = this.state.selection
        if(event.target.checked) {
          selection.add(event.target.value)
        } else {
          selection.delete(event.target.value)
        }
        this.setState({ selection : selection });
      };

    handleConvert = async () => {
        if(this.state.inputFile === null) {
          alert('先に画像を選択してください')
          return
        }
        if(this.state.selection.size === 0) {
          alert('サイズは1つ以上選択してください')
          return
        }
        this.setState({isLoading: true});
        let command = []
        command = command.concat(["convert", this.state.inputFile.name])
        command = Array.from(this.state.selection).reduce((prev, value, index) => {
          if(!(
            value === '16' || 
            value === '24' || 
            value === '32' || 
            value === '48' || 
            value === '64' || 
            value === '128' || 
            value === '256'  
            )) {
              return prev
            }
          const size = value + "x" + value
          const commandList = ["(", "-clone", "0", "-define", "icon", "-resize", size, "-size", size, "xc:none", "+swap", "-gravity", "center", "-composite", ")"]
          return prev.concat(commandList)
        }, command)
          
        command = command.concat(["-delete", "0", "favicon.ico"])

        const result = await call([this.state.inputFile], command);

        if(result.exitCode == 0) {
            this.setState({outputImage: URL.createObjectURL(result.outputFiles[0].blob)});
        } else {
            alert('変換に失敗しました')
        }
        this.setState({isLoading: false});
 

    }

    handleChangeFile = async (e) => {
        var files = e.target.files;
        // 元画像プレビュー表示用
        this.setState({inputImage: URL.createObjectURL(files[0])})

        const buffer = await this.readFileAsync(files[0])
        const uint8 = new Uint8Array(buffer)

        this.setState({inputFile: {content:uint8, name: files[0].name}});
   }

    render() {
        const { classes } = this.props;
        return (
          <Grid container>
            <Grid item xs={12}>
              <p>変換する画像ファイルを選択してください</p>
              <Button variant="contained" color="primary" className={classes.button} component="label">
                  変換する画像を選択する
                  <CloudUploadIcon className={classes.rightIcon}/>
                  <input type="file" rel="file" onChange={this.handleChangeFile} className={classes.inputFileBtnHide} />
              </Button>
            </Grid>

            <Grid item xs={12}>
              <p>作成するサイズを指定してください。 複数選択した場合は、マルチアイコンとして作成されます。</p>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={this.handleChange.bind(this)}
                    value="16"
                    color="primary"
                  />
                }
                label="16x16"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={this.handleChange.bind(this)}
                    value="24"
                    color="primary"
                  />
                }
                label="24x24"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={this.handleChange.bind(this)}
                    value="32"
                    color="primary"
                  />
                }
                label="32x32"
              />
 
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={this.handleChange.bind(this)}
                    value="48"
                    color="primary"
                  />
                }
                label="48x48"
              />
 
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={this.handleChange.bind(this)}
                    value="64"
                    color="primary"
                  />
                }
                label="64x64"
              />
 
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={this.handleChange.bind(this)}
                    value="128"
                    color="primary"
                  />
                }
                label="128x128"
              />
 
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={this.handleChange.bind(this)}
                    value="256"
                    color="primary"
                  />
                }
                label="256x256"
              />
 
            </Grid>
 


            <Grid item xs={12}>
              <Button variant="contained" color="primary" className={classes.button} component="label" onClick={this.handleConvert}>
                  画像を変換する
                  {/* <CloudUploadIcon className={classes.rightIcon}/> */}
              </Button>
              { this.state.isLoading && <CircularProgress />}
            </Grid>


            <Grid item xs={12} md={6}>
              <p>元画像</p>
              <img src={this.state.inputImage} className={classes.inputImg} />
            </Grid>
            <Grid item xs={12} md={6}>
              <p>変換後画像(favicon.ico)</p>
              <img src={this.state.outputImage} className={classes.outputImg} />
            </Grid>
            <Grid item xs={12}>
              {(() => {
                  if(this.state.outputImage !== ''){
                          return (
                            <div>
                              <p>市松模様になっている箇所は、透過を表しています。</p>
                              <p>表示結果、エラー等の問題がなければ下記からダウンロードしていただけます。</p>
                                <a href={this.state.outputImage} download="favicon.ico">
                                <Button variant="contained" color="primary" className={classes.button} component="label">
                                    ダウンロード
                                    <CloudDownloadIcon className={classes.rightIcon}/>
                                </Button>
                              </a>
                            </div>
                          )
                      }
                  })
              ()}
            </Grid>
          </Grid>
        )
    }
}

export default withStyles(styles)(ImageUploadButton);
